import { formatDateLocale } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './FormattedDate.module.scss'

const FormattedDate = ({ date, size, status }) => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  if (size === 'big') {
    return (
      <div className={styles['lg-date']}>
        <span className={styles['lg-date__label']}>{t(`countdown.label.${status}`)}</span>
        <span className={styles['lg-date__value']}>{formatDateLocale(date, currentLanguage)}</span>
      </div>
    )
  }

  return (
    <div>
      <div className={styles['default-label']}>{t(`countdown.label.${status}`)}</div>
      <div className={styles['default-value']}>{formatDateLocale(date, currentLanguage)}</div>
    </div>
  )
}

export default FormattedDate
